// This file is auto-generated by next/scripts/writeExperimentData.ts
// do not edit directly
import { ReferencedMiddlewareExperiment } from "@brexhq/next/src/utils/experimentation/createMiddlewareConfig";
export const routes = {
  "/product/bill-pay": {
    statsigExperimentId: "bill_pay_page_-_new_h1_headline_-_above_the_fold",
    experimentStatus: "active",
    defaultParameterValue: "This is automated bill pay made better.",
    parameterKey: "H1 headline",
    routes: {
      "This is automated bill pay made better.":
        "/br-exp/5c8a0eb7e1ba4cf3ad630e044af0afe1",
      "Automated bill pay software built for accuracy, speed, & control.":
        "/br-exp/933466b8fdc2448fbd8b3f217e37c819",
    },
  },
  "/versus/concur": {
    statsigExperimentId: "concur_primary_cta",
    experimentStatus: "active",
    defaultParameterValue: "Get started",
    parameterKey: "CTA",
    routes: {
      "Get started": "/br-exp/cd6d059d465b4860a7b202928b2b5e9e",
      "Try Brex for free": "/br-exp/69d508032e8d497cb5e7a46c9744e132",
    },
  },
  "/product/spend-management": {
    statsigExperimentId: "spend_management_page_-_spend_trends_-_cta",
    experimentStatus: "active",
    defaultParameterValue: "The future of spend management",
    parameterKey: "H1 headline",
    routes: {
      "The future of spend management":
        "/br-exp/4fa0abf5a9334e458314456ac16efcdd",
      "Spend management built for complete control and visibility":
        "/br-exp/23704e544c68491a9fc8429d929658e3",
    },
  },
  "/product/travel-expense-management": {
    statsigExperimentId: "travel_and_expense_management_page_-_logo_garden",
    experimentStatus: "setup",
    defaultParameterValue: "No",
    parameterKey: "Logo Garden in Second Fold",
    routes: {
      No: "/br-exp/e5351fa292084ecf8a80fcd18ab1e924",
      Yes: "/br-exp/17476eeeee774ee8b47ad57713d42671",
    },
  },
  "/spend-trends/business-banking/business-lines-of-credit-for-startups": {
    statsigExperimentId: "business_line_of_credit_page_-_cta_copy",
    experimentStatus: "active",
    defaultParameterValue: "See why 1 in 3 startups",
    parameterKey: "CTA Copy",
    parent: "spendTrends",
    routes: {
      "See why 1 in 3 startups": "/br-exp/093ad5b04fdb42bfbe085b4b1ed44e2c",
      "Get a brex card with your EIN-only":
        "/br-exp/19abfcba493b4bb38d7dd39b3ff0ab54",
    },
  },
  "/resources/accounting-automation-guide": {
    statsigExperimentId: "gated_content_-_form_complete",
    experimentStatus: "active",
    defaultParameterValue: "Original Form",
    parameterKey: "Form Type",
    parent: "resources",
    routes: {
      "Original Form": "/br-exp/0cf54572f64e460e800e8c691798128a",
      "Form Complete": "/br-exp/3d8f3e5d831d48a68e93c16b77c90f54",
    },
  },
  "/spend-trends/corporate-credit-cards/high-limit-business-credit-cards": {
    statsigExperimentId:
      "high_limit_card_page_-_bottom_cta_-_how_high_can_your_limit_go",
    experimentStatus: "active",
    defaultParameterValue: "Give you business the flexibility",
    parameterKey: "Bottom CTA copy",
    parent: "spendTrends",
    routes: {
      "Give you business the flexibility":
        "/br-exp/b79e41291bd545f291ca3ea273222b6f",
      "How high can your limit go?": "/br-exp/8dfb9fbb3b5a49888989e08fdbc9eef2",
    },
  },
  "/resources/unlock-value-with-ai-powered-accounting-register": {
    statsigExperimentId: "gated_content_-_form_complete",
    experimentStatus: "active",
    defaultParameterValue: "Original Form",
    parameterKey: "Form Type",
    parent: "resources",
    routes: {
      "Original Form": "/br-exp/7d17a64f05364b098a013ce849498a4b",
      "Form Complete": "/br-exp/2f536f5e4f9f4d13bc70d141add40324",
    },
  },
  "/spend-trends/startup/pre-seed-vs-seed-funding-round": {
    statsigExperimentId: "pre-seed_vs_seed_funding_-_spend_trends_-_cta",
    experimentStatus: "active",
    defaultParameterValue:
      "Brex is trusted by 1 in 3 startups for credit cards and spend management - are you next?",
    parameterKey: "Bottom CTA",
    parent: "spendTrends",
    routes: {
      "Brex is trusted by 1 in 3 startups for credit cards and spend management - are you next?":
        "/br-exp/3d61f0e1bd3a48ce971f10cb248b4672",
      "Silicon Valley's secret: Brex cards for startups. Zero credit checks. Higher credit limits. No personal guarantee required.":
        "/br-exp/28d65dda0b0d4dfc9a4c46ccf1d81224",
    },
  },
  "/resources/2025-cfo-survey-register": {
    statsigExperimentId: "gated_content_-_form_complete",
    experimentStatus: "active",
    defaultParameterValue: "Original Form",
    parameterKey: "Form Type",
    parent: "resources",
    routes: {
      "Original Form": "/br-exp/834aab558b2e4a168887232bf980e01c",
      "Form Complete": "/br-exp/96324ee5226e40758a37e86cdf107005",
    },
  },
  "/resources/startups-guide-to-modern-banking-register": {
    statsigExperimentId: "gated_content_-_form_complete",
    experimentStatus: "active",
    defaultParameterValue: "Original Form",
    parameterKey: "Form Type",
    parent: "resources",
    routes: {
      "Original Form": "/br-exp/ba15114de41c48d0b3e814e96e095490",
      "Form Complete": "/br-exp/da0bcc22af5d443b9b226e9476230b8b",
    },
  },
  "/resources/cfo-guide-ai-strategy-register": {
    statsigExperimentId: "gated_content_-_form_complete",
    experimentStatus: "active",
    defaultParameterValue: "Original Form",
    parameterKey: "Form Type",
    parent: "resources",
    routes: {
      "Original Form": "/br-exp/9a0a2b57cfb0438fbcd92529fb1c3900",
      "Form Complete": "/br-exp/4b729dcf07744b88a932a8fbab1b8a32",
    },
  },
  "/resources/customer/doordash": {
    statsigExperimentId: "doordash_-_bottom_cta",
    experimentStatus: "active",
    defaultParameterValue: "no",
    parameterKey: "CTA at the bottom",
    parent: "resources",
    routes: {
      no: "/br-exp/084f3a041cc84289b2f3f6ac16a30e5c",
      yes: "/br-exp/22327719974e42e79e93af1a44bfbe87",
    },
  },
  "/spend-trends/budget-management/how-to-budget-for-recurring-expenses": {
    statsigExperimentId: "recurring_expenses_-_spend_trends_-_bottom_cta",
    experimentStatus: "active",
    defaultParameterValue: "No",
    parameterKey: "Bottom CTA",
    parent: "spendTrends",
    routes: {
      No: "/br-exp/6228d5f0c43a40c9b2a570e98a5a166f",
      Yes: "/br-exp/31ce8ccc6feb41d5ad48cfebc7bffdc1",
    },
  },
};
export const encodedUrls = {
  "5c8a0eb7e1ba4cf3ad630e044af0afe1": {
    experimentStatus: "active",
    sanityFetchPageId: "426e75fb-8536-47c9-8455-32b1377a68b9",
    experimentId: "bill_pay_page_-_new_h1_headline_-_above_the_fold",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/bill-pay",
  },
  "933466b8fdc2448fbd8b3f217e37c819": {
    experimentStatus: "active",
    sanityFetchPageId: "426e75fb-8536-47c9-8455-32b1377a68b9",
    experimentId: "bill_pay_page_-_new_h1_headline_-_above_the_fold",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/bill-pay",
  },
  cd6d059d465b4860a7b202928b2b5e9e: {
    experimentStatus: "active",
    sanityFetchPageId: "7b2352e2-fd63-448e-92ce-a3948b8b3c14",
    experimentId: "concur_primary_cta",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "versus/concur",
  },
  "69d508032e8d497cb5e7a46c9744e132": {
    experimentStatus: "active",
    sanityFetchPageId: "7b2352e2-fd63-448e-92ce-a3948b8b3c14",
    experimentId: "concur_primary_cta",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "versus/concur",
  },
  "4fa0abf5a9334e458314456ac16efcdd": {
    experimentStatus: "active",
    sanityFetchPageId: "9cb1812a-dd34-4dec-ba61-f10abee02e15",
    experimentId: "spend_management_page_-_spend_trends_-_cta",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/spend-management",
  },
  "23704e544c68491a9fc8429d929658e3": {
    experimentStatus: "active",
    sanityFetchPageId: "9cb1812a-dd34-4dec-ba61-f10abee02e15",
    experimentId: "spend_management_page_-_spend_trends_-_cta",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/spend-management",
  },
  e5351fa292084ecf8a80fcd18ab1e924: {
    experimentStatus: "setup",
    sanityFetchPageId: "ffb99b9a-9633-470d-bfa8-c8dd5731c165",
    experimentId: "travel_and_expense_management_page_-_logo_garden",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/travel-expense-management",
  },
  "17476eeeee774ee8b47ad57713d42671": {
    experimentStatus: "setup",
    sanityFetchPageId: "ffb99b9a-9633-470d-bfa8-c8dd5731c165",
    experimentId: "travel_and_expense_management_page_-_logo_garden",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "product/travel-expense-management",
  },
  "093ad5b04fdb42bfbe085b4b1ed44e2c": {
    experimentStatus: "active",
    sanityFetchPageId: "0afc073b-4807-41e2-96c6-635b44f89121",
    experimentId: "business_line_of_credit_page_-_cta_copy",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "business-banking/business-lines-of-credit-for-startups",
  },
  "19abfcba493b4bb38d7dd39b3ff0ab54": {
    experimentStatus: "active",
    sanityFetchPageId: "0afc073b-4807-41e2-96c6-635b44f89121",
    experimentId: "business_line_of_credit_page_-_cta_copy",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "business-banking/business-lines-of-credit-for-startups",
  },
  "0cf54572f64e460e800e8c691798128a": {
    experimentStatus: "active",
    sanityFetchPageId: "1a547273-dfb9-4c03-a47b-ea74ec86266b",
    experimentId: "gated_content_-_form_complete",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "accounting-automation-guide",
  },
  "3d8f3e5d831d48a68e93c16b77c90f54": {
    experimentStatus: "active",
    sanityFetchPageId: "1a547273-dfb9-4c03-a47b-ea74ec86266b",
    experimentId: "gated_content_-_form_complete",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "accounting-automation-guide",
  },
  b79e41291bd545f291ca3ea273222b6f: {
    experimentStatus: "active",
    sanityFetchPageId: "2237680d-6601-4dc9-ae25-9ec6b1b68cfe",
    experimentId:
      "high_limit_card_page_-_bottom_cta_-_how_high_can_your_limit_go",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "corporate-credit-cards/high-limit-business-credit-cards",
  },
  "8dfb9fbb3b5a49888989e08fdbc9eef2": {
    experimentStatus: "active",
    sanityFetchPageId: "2237680d-6601-4dc9-ae25-9ec6b1b68cfe",
    experimentId:
      "high_limit_card_page_-_bottom_cta_-_how_high_can_your_limit_go",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "corporate-credit-cards/high-limit-business-credit-cards",
  },
  "7d17a64f05364b098a013ce849498a4b": {
    experimentStatus: "active",
    sanityFetchPageId: "3f8920df-5aad-452e-9980-6aac20dffb79",
    experimentId: "gated_content_-_form_complete",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "unlock-value-with-ai-powered-accounting-register",
  },
  "2f536f5e4f9f4d13bc70d141add40324": {
    experimentStatus: "active",
    sanityFetchPageId: "3f8920df-5aad-452e-9980-6aac20dffb79",
    experimentId: "gated_content_-_form_complete",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "unlock-value-with-ai-powered-accounting-register",
  },
  "3d61f0e1bd3a48ce971f10cb248b4672": {
    experimentStatus: "active",
    sanityFetchPageId: "787b45ee-1d54-44fd-9eed-43dbc059280c",
    experimentId: "pre-seed_vs_seed_funding_-_spend_trends_-_cta",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "startup/pre-seed-vs-seed-funding-round",
  },
  "28d65dda0b0d4dfc9a4c46ccf1d81224": {
    experimentStatus: "active",
    sanityFetchPageId: "787b45ee-1d54-44fd-9eed-43dbc059280c",
    experimentId: "pre-seed_vs_seed_funding_-_spend_trends_-_cta",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "startup/pre-seed-vs-seed-funding-round",
  },
  "834aab558b2e4a168887232bf980e01c": {
    experimentStatus: "active",
    sanityFetchPageId: "9e546d16-2499-43c4-9912-153c24b475ef",
    experimentId: "gated_content_-_form_complete",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "2025-cfo-survey-register",
  },
  "96324ee5226e40758a37e86cdf107005": {
    experimentStatus: "active",
    sanityFetchPageId: "9e546d16-2499-43c4-9912-153c24b475ef",
    experimentId: "gated_content_-_form_complete",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "2025-cfo-survey-register",
  },
  ba15114de41c48d0b3e814e96e095490: {
    experimentStatus: "active",
    sanityFetchPageId: "a343383b-1ccd-400f-87af-e14426681bca",
    experimentId: "gated_content_-_form_complete",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "startups-guide-to-modern-banking-register",
  },
  da0bcc22af5d443b9b226e9476230b8b: {
    experimentStatus: "active",
    sanityFetchPageId: "a343383b-1ccd-400f-87af-e14426681bca",
    experimentId: "gated_content_-_form_complete",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "startups-guide-to-modern-banking-register",
  },
  "9a0a2b57cfb0438fbcd92529fb1c3900": {
    experimentStatus: "active",
    sanityFetchPageId: "b5156e65-c62e-4416-b329-4be01146b9f7",
    experimentId: "gated_content_-_form_complete",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "cfo-guide-ai-strategy-register",
  },
  "4b729dcf07744b88a932a8fbab1b8a32": {
    experimentStatus: "active",
    sanityFetchPageId: "b5156e65-c62e-4416-b329-4be01146b9f7",
    experimentId: "gated_content_-_form_complete",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "cfo-guide-ai-strategy-register",
  },
  "084f3a041cc84289b2f3f6ac16a30e5c": {
    experimentStatus: "active",
    sanityFetchPageId: "bbf16e8c-f11d-41f6-98cc-f3aebd601658",
    experimentId: "doordash_-_bottom_cta",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "customer/doordash",
  },
  "22327719974e42e79e93af1a44bfbe87": {
    experimentStatus: "active",
    sanityFetchPageId: "bbf16e8c-f11d-41f6-98cc-f3aebd601658",
    experimentId: "doordash_-_bottom_cta",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "customer/doordash",
  },
  "6228d5f0c43a40c9b2a570e98a5a166f": {
    experimentStatus: "active",
    sanityFetchPageId: "fe2f08c4-476d-4167-9286-fe515842648d",
    experimentId: "recurring_expenses_-_spend_trends_-_bottom_cta",
    variation: "Control",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "budget-management/how-to-budget-for-recurring-expenses",
  },
  "31ce8ccc6feb41d5ad48cfebc7bffdc1": {
    experimentStatus: "active",
    sanityFetchPageId: "fe2f08c4-476d-4167-9286-fe515842648d",
    experimentId: "recurring_expenses_-_spend_trends_-_bottom_cta",
    variation: "Test",
    isExperiment: true,
    experimentType: "module",
    fallBackSlug: "budget-management/how-to-budget-for-recurring-expenses",
  },
};
export const navExperiment: ReferencedMiddlewareExperiment | null = null;
export const bannerExperiment: ReferencedMiddlewareExperiment | null = null;
export const footerExperiment: ReferencedMiddlewareExperiment | null = null;
